import { useMemo } from "react";
import { verifyPermission } from "helpers/permission";

export const usePermissions = (userPermissions) => {
  return useMemo(() => {
    return {
      canViewAnyClients: verifyPermission(
        userPermissions,
        "list-client-from-any-institution"
      ),
      canViewMyClients: verifyPermission(
        userPermissions,
        "list-client-from-my-institution"
      ),
      canAddAnyClient: verifyPermission(
        userPermissions,
        "store-client-from-any-institution"
      ),
      canAddMyClient: verifyPermission(
        userPermissions,
        "store-client-from-my-institution"
      ),
      canEditAnyClient: verifyPermission(
        userPermissions,
        "update-client-from-any-institution"
      ),
      canEditMyClient: verifyPermission(
        userPermissions,
        "update-client-from-my-institution"
      ),
      canDeleteAnyClient: verifyPermission(
        userPermissions,
        "destroy-client-from-any-institution"
      ),
      canDeleteMyClient: verifyPermission(
        userPermissions,
        "destroy-client-from-my-institution"
      ),

      canViewClients:
        verifyPermission(userPermissions, "list-client-from-my-institution") ||
        verifyPermission(userPermissions, "list-client-from-any-institution"),
      canAddClient:
        verifyPermission(userPermissions, "store-client-from-my-institution") ||
        verifyPermission(userPermissions, "store-client-from-any-institution"),
      canEditClient:
        verifyPermission(
          userPermissions,
          "update-client-from-my-institution"
        ) ||
        verifyPermission(userPermissions, "update-client-from-any-institution"),
      canDeleteClient:
        verifyPermission(
          userPermissions,
          "destroy-client-from-my-institution"
        ) ||
        verifyPermission(
          userPermissions,
          "destroy-client-from-any-institution"
        ),
    };
  }, [userPermissions]);
};
